var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6007A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.357 3.6A6.374 6.374 0 0 0 7.87 5.473a6.404 6.404 0 0 0-1.534 6.57.911.911 0 0 0 1.117.56.906.906 0 0 0 .542-1.12 4.183 4.183 0 0 1-.247-1.622 4.589 4.589 0 0 1 5.46-4.376c.874.17 1.679.59 2.317 1.211a4.6 4.6 0 0 1 1.109 4.898 4.597 4.597 0 0 1-1.569 2.095 4.58 4.58 0 0 1-2.455.897s-.89.056-1.336.112a4.578 4.578 0 0 0-.487.096.06.06 0 0 1-.078-.006.06.06 0 0 1-.006-.078l.14-.756.837-3.802a.874.874 0 0 0-.67-1.035.869.869 0 0 0-1.033.672s-1.994 9.283-1.994 9.367a.85.85 0 0 0 .666 1.035.85.85 0 0 0 1.033-.672c.028-.112.28-1.343.28-1.343a2.264 2.264 0 0 1 1.87-1.783c.191-.028 1.001-.084 1.001-.084a6.348 6.348 0 0 0 4.19-2.14 6.377 6.377 0 0 0-.327-8.75A6.346 6.346 0 0 0 12.357 3.6Zm1.589 14.675a1.064 1.064 0 0 0-1.256.84 1.058 1.058 0 0 0 .837 1.26 1.033 1.033 0 0 0 1.1-.45 1.02 1.02 0 0 0 .153-.39 1.106 1.106 0 0 0-.834-1.26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.6ad80550932ce5219816015f5e9efd38.svg";
export { ForwardRef as ReactComponent };